export default __webpack_public_path__ + "static/media/neck-blue.0c75469d.png";